import React, { useEffect, useState } from "react";
import '../styles/login-page.style.scss';
import { Form, Input , Button, message} from 'antd';
import { userLogin ,setRunSplashScreen, setLoginUserDetails , verifyOtp, getServerUrlByUserName, setServerUrl, getPrepaidOtaAgentIdByServerUrl, setPrepaidOtaAgentId, setPrepaidOtaTravelsId} from '../actions/user.action';
import { useDispatch , useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { runSplashScreenSelector } from './../selector/user.selector';
import { LoadingSpinner } from './../components/custom-components/custom-component';
import { LOGIN_ACCESS_TOKEN_KEY , AGENT_COLORS_ACCESS_TOKEN_KEY, DAFIDY_USER, logoLoginStyle, SERVER_URL_ACCESS_TOKEN_KEY, LOGIN_USER_NAME_KEY} from './../utils/constant';
import { getLocalStorage, isValid ,setAgentPortalColors,setLocalStorage} from './../utils/utilities';
import { updateUrls } from '../utils/api-url';
import { API_NORTH_BASE_URL, API_SRMS_BASE_URL, API_B2B_BASE_URL, APP_ENV, B2B_PROD_ENV, PROD_ENV } from '../app.config';
const tempLoginCredentials = 'temp_login_credentials';

export const LoginPage = () => {

    const dispatch=useDispatch();
    const history=useHistory();
    const runSplashScreen = useSelector(runSplashScreenSelector);
    const [showOtpContent , setShowOtpContent] = useState(false);
    const [apiResult , setApiResult] = useState({});

    const onFinish = (values) => {
        let {
            username,
            password
        }=values;
        if (!isValid(global.serverUrl) || username != global.userName){
            getServerUrlByUserName(username,(serverUrl)=>{
                dispatch(setServerUrl(serverUrl));
                setLocalStorage(tempLoginCredentials,JSON.stringify({username,password}));
                setLocalStorage(SERVER_URL_ACCESS_TOKEN_KEY,JSON.stringify(serverUrl));
                updateUrls();
                window.location.reload();
            });
        }else{
            loginDispatch(username,password,null);
        }
      };

      const loginDispatch=(username,password,access_code)=>{
        if (!isValid(global.serverUrl)){
            let serverUrlString = getLocalStorage(SERVER_URL_ACCESS_TOKEN_KEY);
            let serverUrl = JSON.parse(serverUrlString);
            if (isValid(serverUrl)){
                dispatch(setServerUrl(serverUrl));
                updateUrls();
            }
        }
        dispatch(userLogin(username,password,access_code,(clientPayload)=>{
            if(clientPayload.verify_otp_for_login === 1){
                setShowOtpContent(true);
                setApiResult(clientPayload);
            }else{
                onLogin(clientPayload);
            }
        }));
      }

      const onLogin=(clientPayload)=>{
        setLocalStorage(LOGIN_ACCESS_TOKEN_KEY,clientPayload.access_code);
        if(isValid(clientPayload.user_name)){
            setLocalStorage(LOGIN_USER_NAME_KEY, clientPayload.user_name);
        }
        dispatch(setLoginUserDetails(clientPayload));
        let pathName = 'home';
        if(clientPayload.privilege === DAFIDY_USER){
            pathName = 'report/webticketsalesreport';
        }else if(clientPayload.privilege == 'Prepaid-OTA' || clientPayload.privilege == 'Postpaid-OTA'){
            pathName= 'prepaid-ota';
            let serversToCall = {};
            if (APP_ENV === B2B_PROD_ENV) {
                global.prepaidOtaB2bAgentId = clientPayload.id;
                global.prepaidOtaB2bTravelsId = clientPayload.travels_id;
                dispatch(setPrepaidOtaAgentId("b2b", clientPayload.id));
                dispatch(setPrepaidOtaTravelsId("b2b", clientPayload.travels_id));
                serversToCall = {"north": API_NORTH_BASE_URL, "srms": API_SRMS_BASE_URL};
            }
            else if (APP_ENV === PROD_ENV) {
                global.prepaidOtaSrmsAgentId = clientPayload.id;
                global.prepaidOtaSrmsTravelsId = clientPayload.travels_id;
                dispatch(setPrepaidOtaAgentId("srms", clientPayload.id));
                dispatch(setPrepaidOtaTravelsId("srms", clientPayload.travels_id));
                serversToCall = {"north": API_NORTH_BASE_URL, "b2b": API_B2B_BASE_URL};
            }
            else {
                global.prepaidOtaB2bAgentId = clientPayload.id;
                global.prepaidOtaSrmsAgentId = clientPayload.id;
                global.prepaidOtaNorthAgentId = clientPayload.id;
                global.prepaidOtaNorthTravelsId = clientPayload.travels_id;
                global.prepaidOtaB2bTravelsId = clientPayload.travels_id;
                global.prepaidOtaSrmsTravelsId = clientPayload.travels_id;
                dispatch(setPrepaidOtaAgentId("b2b", clientPayload.id));
                dispatch(setPrepaidOtaTravelsId("b2b", clientPayload.travels_id));
                dispatch(setPrepaidOtaAgentId("srms", clientPayload.id));
                dispatch(setPrepaidOtaTravelsId("srms", clientPayload.travels_id));
                dispatch(setPrepaidOtaAgentId("north", clientPayload.id));
                dispatch(setPrepaidOtaTravelsId("north", clientPayload.travels_id));
            }
            if (Object.keys(serversToCall).length > 0) {
                Object.keys(serversToCall).forEach(server => {
                    getPrepaidOtaAgentIdByServerUrl(serversToCall[server], clientPayload.user_name, ({prepaidOtaAgentId, prepaidOtaTravelsId})=> {
                        if (server === "north") {
                            global.prepaidOtaNorthAgentId = prepaidOtaAgentId;
                            global.prepaidOtaNorthTravelsId = prepaidOtaTravelsId;
                            dispatch(setPrepaidOtaAgentId(server, prepaidOtaAgentId));
                            dispatch(setPrepaidOtaTravelsId(server, prepaidOtaTravelsId));
                        }
                        else if (server === "srms") {
                            global.prepaidOtaSrmsAgentId = prepaidOtaAgentId;
                            global.prepaidOtaSrmsTravelsId = prepaidOtaTravelsId;
                            dispatch(setPrepaidOtaAgentId(server, prepaidOtaAgentId));
                            dispatch(setPrepaidOtaTravelsId(server, prepaidOtaTravelsId));
                        }
                        else if (server === "b2b") {
                            global.prepaidOtaB2bAgentId = prepaidOtaAgentId;
                            global.prepaidOtaB2bTravelsId = prepaidOtaTravelsId;
                            dispatch(setPrepaidOtaAgentId(server, prepaidOtaAgentId));
                            dispatch(setPrepaidOtaTravelsId(server, prepaidOtaTravelsId));
                        }
                    }, ()=> {
                        message.error("Failed to get prepaid ota agent id");
                    });
                });
            }
        }
        if(isValid(global.loginPathName)&&global.loginPathName !== '/'){
            pathName = global.loginPathName;
            if(isValid(global.loginSearch)){
                pathName = pathName + global.loginSearch;
            }
        }
        history.push(pathName);
      }

      useEffect(()=>{
        let accessCode = getLocalStorage(LOGIN_ACCESS_TOKEN_KEY);
        let agentPortalColors = getLocalStorage(AGENT_COLORS_ACCESS_TOKEN_KEY);
        let tempCredentials = getLocalStorage(tempLoginCredentials);

        if(isValid(agentPortalColors)){
            agentPortalColors=JSON.parse(agentPortalColors);
            setAgentPortalColors(agentPortalColors);
        }

        if (isValid(tempCredentials)){
            let credentials = JSON.parse(tempCredentials);
            let username = credentials.username;
            let password = credentials.password;
            localStorage.removeItem(tempLoginCredentials);
            loginDispatch(username,password,null);
        }
        else {
            if(isValid(accessCode)){
                let savedUserName = getLocalStorage(LOGIN_USER_NAME_KEY);
                if(isValid(savedUserName)){
                    getServerUrlByUserName(savedUserName,(serverUrl)=>{
                        if(isValid(serverUrl)){
                            dispatch(setServerUrl(serverUrl));
                            setLocalStorage(SERVER_URL_ACCESS_TOKEN_KEY,JSON.stringify(serverUrl));
                            updateUrls();
                        }
                        loginDispatch(null,null,accessCode);
                    });
                }else{
                    loginDispatch(null,null,accessCode);
                }
            }else{
                dispatch(setRunSplashScreen(false));
            }
        }
      },[]);

      const onFinishVerifyOtp=(values)=>{
          let {
            otp
          } = values;
        dispatch(verifyOtp(otp,apiResult.phone_number,()=>{
            onLogin(apiResult);
            setShowOtpContent(false);
        }));
      }

    if(runSplashScreen){
        return <div className="login-form-root">
                    <LoadingSpinner />
                </div>
    }
    if(showOtpContent){
        return (
                <div className="login-form-root">
                    <div className='login-form-secondary'>
                        <p>{`Verification code is sent to your phone number , ${apiResult.phone_number}`}</p>
                        <p>Please enter the verification code.</p>
                        <Form
                        onFinish={onFinishVerifyOtp}
                        >
                                <Form.Item
                                name={'otp'}
                                >
                                    <Input placeholder="Enter your OTP!" />
                                </Form.Item>
                                <Form.Item>
                                    <Button block type="primary" htmlType="submit" className="btn-lg">
                                        Verify
                                    </Button>
                                </Form.Item>
                        </Form>
                    </div>
            </div>
        )
    }
    return (
        <div className="login-form-root">
            <div className="login-secondary-container">
                <div className="login-form-header"> 
                    <img src={require('./../images/qwikbus-logo.png')} alt="QwikBus" style={logoLoginStyle} />
                </div>
                <div className='login-form-secondary'>
                    <h3 className="heading-div">Welcome to the Agent Booking Portal</h3>
                    <div>
                            <Form
                                name="normal_login"
                                className="login-form"
                                initialValues={{ remember: true }}
                                onFinish={onFinish}
                                >
                                    <Form.Item
                                        name="username"
                                        rules={[{ required: true, message: 'Please input your Username!' }]}
                                    >
                                        <Input
                                        // prefix={<UserOutlined className="site-form-item-icon" />}
                                        placeholder="Enter Username"
                                        className="defalut-input-style"
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        name="password"
                                        rules={[{ required: true, message: 'Please input your Password!' }]}
                                    >
                                        <Input
                                        // prefix={<LockOutlined className="site-form-item-icon" />}
                                        type="password"
                                        placeholder="Enter Password"
                                        className="defalut-input-style"
                                        />
                                    </Form.Item>
                                    <div className="login-form-button">
                                        <Form.Item >
                                            <Button type="primary" htmlType="submit">
                                                Sign in
                                            </Button>
                                        </Form.Item>
                                    </div>
                                </Form>
                    </div>
                </div>
                </div> 
               <div className="login-form-footer"> 
                Powered by QwikBus <br/>
               </div>
        </div>
    );
}
